import { AvailableModules, Features } from 'generated/featureDefinitions'

import i18n from 'modules/core/lib/i18n'

import { ValidReasons } from 'modules/upsell/hooks/useCreateUpsellRequest'
import { UpsellingKit } from 'modules/upselling_kit/components'

import { ProjectsUpsellRequestSources } from '../constants'

interface UpsellProp {
  projectsMissing: boolean
}

export const UpsellProjectInvoices = ({ projectsMissing }: UpsellProp) => {
  return (
    <UpsellingKit.EmptyState
      moduleRequested={projectsMissing ? AvailableModules.projects : AvailableModules.sales}
      featureRequested={Features.sales_invoices_management}
      requestReason={ValidReasons.UpgradeFromLegacy}
      requestSource={ProjectsUpsellRequestSources.projectSalesInvoices}
      title={i18n.t('project_management.upselling.title')}
      description={i18n.t('project_management.upselling.invoices')}
      buttonLabel={i18n.t('project_management.upselling.cta')}
      variant="table"
    />
  )
}
